import { Link } from "react-router-dom";
import { mockServices } from "../../../mocks/services";

export default function ServicesOverview() {
  return (
    <section className="py-24 lg:py-32 px-8 lg:px-14 bg-arch-cream">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-16 gap-6">
        <div>
          <p className="text-arch-light text-xs tracking-[0.2em] uppercase mb-3">What We Do</p>
          <h2 className="font-serif text-4xl lg:text-5xl text-arch-charcoal font-light leading-tight">
            Services
          </h2>
        </div>
        <p className="text-arch-gray text-sm font-light leading-relaxed max-w-sm">
          From the first sketch to final construction, Studio 1323 provides comprehensive architectural services across Santa Monica and Los Angeles.
        </p>
      </div>

      {/* Broken grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {mockServices.map((service, i) => (
          <Link
            key={service.id}
            to={service.href}
            className={`group block cursor-pointer ${i === 1 ? "lg:mt-16" : ""} ${i === 3 ? "lg:mt-0" : ""}`}
          >
            <div className="overflow-hidden rounded-lg">
              <div className="w-full h-64 lg:h-72 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title + " — Studio 1323"}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
            </div>
            <div className="pt-6 flex items-start justify-between">
              <div>
                <p className="text-arch-light text-xs tracking-[0.15em] uppercase mb-1">{service.tagline}</p>
                <h3 className="font-serif text-2xl text-arch-charcoal font-light">{service.title}</h3>
                <p className="mt-2 text-arch-gray text-sm font-light leading-relaxed max-w-xs">{service.description}</p>
              </div>
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-arrow-right-line text-arch-charcoal group-hover:translate-x-1 transition-transform text-lg" />
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-14 text-center">
        <Link
          to="/services"
          className="inline-flex items-center gap-2 border border-arch-charcoal text-arch-charcoal px-8 py-3.5 text-xs tracking-[0.15em] uppercase font-medium hover:bg-arch-charcoal hover:text-white transition-all rounded-md cursor-pointer whitespace-nowrap"
        >
          All Services
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </section>
  );
}
